/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { ActionComposerEditorArgs } from 'cio/components/action-composer/base-glimmer/editor';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { gt, reads } from '@ember/object/computed';
import { isEmpty } from '@ember/utils';
import { Platform, PLATFORM_LABELS } from 'cio/utils/push/platforms';
import { DEFAULT_CUSTOM_PAYLOAD_BODY_JSON } from 'cio/utils/push/custom-payload';
import PushService from 'cio/services/push';
import RichEditor from 'cio/components/action-composer/types/push/rich-editor';
import NewsletterModel from 'cio/models/newsletter';
import TransactionalMessageModel from 'cio/models/transactional-message';
import ActionModel, { Platform as PlatformModel } from 'cio/models/action';

interface CustomEditorArgs extends ActionComposerEditorArgs {
  currentTab: string;
  onChangeTab: (tab: string) => void;
}

interface CustomEditorSignature {
  Args: CustomEditorArgs;
  Element: HTMLDivElement;
}

export default class CustomEditor extends RichEditor<CustomEditorSignature> {
  @service push!: PushService;

  @reads('push.platforms') enabledPlatforms!: Platform[];

  @gt('enabledPlatforms.length', 1) hasMultiplePlatforms!: boolean;

  @computed('args.editableEntity.{isNewsletter,isTransactionalMessage}')
  private get model() {
    if (this.args.editableEntity.isTransactionalMessage) {
      return this.args.editableEntity.message as TransactionalMessageModel;
    } else if (this.args.editableEntity.isNewsletter) {
      return this.args.editableEntity.newsletter as NewsletterModel;
    } else {
      return this.args.editableEntity.action as ActionModel;
    }
  }

  @computed('model.sendToPlatform')
  get targetPlatformLabel() {
    let { sendToPlatform } = this.model;
    return PLATFORM_LABELS[sendToPlatform];
  }

  @computed('model.{isPlatformSelected,sendToPlatform}')
  get tabs() {
    let { isPlatformSelected, sendToPlatform } = this.model;

    return [
      {
        label: 'Android',
        value: 'android',
        disabled: isPlatformSelected && sendToPlatform !== 'android',
      },
      {
        label: 'iOS',
        value: 'ios',
        disabled: isPlatformSelected && sendToPlatform !== 'ios',
      },
    ];
  }

  constructor(owner: unknown, args: CustomEditorSignature['Args']) {
    super(owner, args);

    if (isEmpty(this.template.bodyJson)) {
      this.template.bodyJson = DEFAULT_CUSTOM_PAYLOAD_BODY_JSON;
    }
  }

  @computed('args.editableEntity.template.bodyJson')
  get payload() {
    return JSON.parse(this.template.bodyJson);
  }

  @action
  onContentChange() {
    let { isPlatformSelected, sendToPlatform } = this.model;
    if (isPlatformSelected && sendToPlatform) {
      if (sendToPlatform === PlatformModel.iOS) {
        this.payload.android = '{}';
      } else if (sendToPlatform === PlatformModel.Android) {
        this.payload.ios = '{}';
      }
    }

    this.template.bodyJson = JSON.stringify(this.payload);
  }
}
